import BudgetPercentageFieldsMobile from './BudgetPercentageFieldsMobile';
import BudgetServiceSelects from '../BudgetServiceSelects';
import RemoveButton from '../RemoveButton';
import { ISelectedServices, IVehicleData } from '../../types';
import { ITruckerPayPlanData } from '../../../../../models/truckerPayPlan';

interface IBudgetServiceFieldsMobileProps {
  serviceId: string;
  failureModeId?: string;
  isExternalService?: boolean;
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  showPercentageFields?: boolean;
  vehicleData?: IVehicleData;
  serviceType: string;
  truckerPayPlan?: ITruckerPayPlanData;
  onServiceChange?: (serviceId: string, serviceData?: any) => void;
  onFailureModeChange?: (failureModeId: string) => void;
  onVolkstotalPercentageChange?: (value: number) => void;
  onDealershipPercentageChange?: (value: number) => void;
  onWarrantyPercentageChange?: (value: number) => void;
  onRemoveService?: () => void;
  onChangeServiceType?: (serviceType: string) => void;
  usedServices: ISelectedServices[];
}

const BudgetServiceFieldsMobile = ({
  serviceId,
  failureModeId,
  isExternalService,
  volkstotalPercentage,
  dealershipPercentage,
  warrantyPercentage,
  showPercentageFields,
  vehicleData,
  serviceType,
  truckerPayPlan,
  usedServices,
  onServiceChange,
  onFailureModeChange,
  onVolkstotalPercentageChange,
  onDealershipPercentageChange,
  onWarrantyPercentageChange,
  onRemoveService,
  onChangeServiceType,
}: IBudgetServiceFieldsMobileProps) => {
  return (
    <div className="flex flex-col gap-4 w-full items-start">
      <div className="flex flex-col gap-4 items-start flex-1 min-w-0 w-full">
        {!isExternalService && (
          <div className="flex w-full flex-shrink-0 mb-3">
            <BudgetServiceSelects
              serviceId={serviceId}
              usedServices={usedServices}
              failureModeId={failureModeId}
              vehicleData={vehicleData}
              serviceType={serviceType}
              truckerPayPlan={truckerPayPlan}
              onChangeItem={(itemId, serviceData) => onServiceChange?.(itemId, serviceData)}
              onChangeModoFalha={(modoFalhaId) => onFailureModeChange?.(modoFalhaId)}
              onChangeServiceType={(newServiceType) => onChangeServiceType?.(newServiceType)}
            />
          </div>
        )}
        <BudgetPercentageFieldsMobile
          volkstotalPercentage={volkstotalPercentage}
          dealershipPercentage={dealershipPercentage}
          warrantyPercentage={warrantyPercentage}
          showPercentageFields={showPercentageFields}
          onVolkstotalPercentageChange={onVolkstotalPercentageChange}
          onDealershipPercentageChange={onDealershipPercentageChange}
          onWarrantyPercentageChange={onWarrantyPercentageChange}
        />
      </div>
      {onRemoveService && (
        <div className="flex items-center flex-shrink-0 self-start w-full">
          <RemoveButton label="Remover serviço" onClick={onRemoveService} />
        </div>
      )}
    </div>
  );
};

export default BudgetServiceFieldsMobile;
